// extracted by mini-css-extract-plugin
export default {"TableContainer":"UOgOhLLxqQPEqyG4ASDA","Table":"H_0Fd3fsQEck7gYu5Tcz","Cell":"mlro83FbBSUqVMee0T00","Td":"dFtpTIYvxTqRu99IKP7c","Th":"ZCdQNZZRgx52pYp0iXaI"};